 /**
 * 方法说明：
 * @author 陈乔 ,E-mail:chenqiao95@qq.com
 * @type 动态计算rem
 * @version 创建时间：2018-7-23
 * @param
 */

 (function (doc, win) {
     var docEl = doc.documentElement,
     //jqmobile可能
         resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
         recalc = function () {
             var clientWidth = docEl.clientWidth;
             if (!clientWidth) return;
             if (clientWidth >= 1920) {
                 docEl.style.fontSize = '16px'; //1rem  = 16px
             } else {
                 docEl.style.fontSize = 16 * (clientWidth / 1920) + 'px';
             }
         };
     if (!doc.addEventListener) return;
     win.addEventListener(resizeEvt, recalc, false);
     doc.addEventListener('DOMContentLoaded', recalc, false);
 })(document, window);